"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.machine = exports.createAppointmentCancelMachine = void 0;
const xstate_1 = require("xstate");
const xstate_2 = require("../../lib/constants/xstate");
const getInitialContext_1 = __importDefault(require("../getInitialContext"));
const actions_1 = __importStar(require("./actions"));
const guards_1 = __importStar(require("./guards"));
const services_1 = __importStar(require("./services"));
const createAppointmentCancelMachine = (initialContext = (0, getInitialContext_1.default)()) => {
    return (0, exports.machine)(initialContext, {
        actions: actions_1.default,
        guards: guards_1.default,
        services: services_1.default
    });
};
exports.createAppointmentCancelMachine = createAppointmentCancelMachine;
const machine = (initialContext = (0, getInitialContext_1.default)(), options = {}) => {
    return (0, xstate_1.createMachine)({
        id: 'appointment-cancel',
        initial: xstate_2.states.initializing,
        context: Object.assign({}, initialContext),
        states: {
            [xstate_2.states.initializing]: {
                on: {
                    [xstate_2.events.initialized]: {
                        target: xstate_2.states.appointment
                    }
                }
            },
            [xstate_2.states.appointment]: {
                initial: xstate_2.states.routing,
                states: {
                    [xstate_2.states.routing]: {
                        always: [
                            {
                                cond: guards_1.wasNotInitializedWithAppointmentData,
                                target: xstate_2.states.error
                            },
                            { cond: guards_1.hasAppointment, target: xstate_2.states.success },
                            { target: xstate_2.states.pending }
                        ]
                    },
                    [xstate_2.states.pending]: {
                        invoke: {
                            id: 'getAppointment',
                            src: services_1.getAppointment,
                            onDone: {
                                actions: actions_1.setAppointment,
                                target: xstate_2.states.success
                            },
                            onError: {
                                target: xstate_2.states.error
                            }
                        }
                    },
                    [xstate_2.states.success]: {
                        type: 'final'
                    },
                    [xstate_2.states.error]: {
                    // Dead end
                    }
                },
                onDone: {
                    target: xstate_2.states.provider
                }
            },
            [xstate_2.states.provider]: {
                initial: xstate_2.states.routing,
                states: {
                    [xstate_2.states.routing]: {
                        always: [
                            {
                                cond: guards_1.shouldSkipProvider,
                                target: xstate_2.states.success
                            },
                            { target: xstate_2.states.pending }
                        ]
                    },
                    [xstate_2.states.pending]: {
                        invoke: {
                            id: 'getProvider',
                            src: services_1.getProvider,
                            onDone: {
                                actions: actions_1.setProvider,
                                target: xstate_2.states.success
                            },
                            onError: {
                                // Should target loadingProviderError, current designs are all or nothing
                                target: xstate_2.states.error
                            }
                        }
                    },
                    [xstate_2.states.success]: {
                        type: 'final'
                    },
                    [xstate_2.states.error]: {
                    // Dead end
                    }
                },
                onDone: [
                    {
                        cond: guards_1.isAppointmentCanceled,
                        target: xstate_2.states.canceledPreviously
                    },
                    {
                        cond: guards_1.hasAppointmentBeenMissed,
                        target: xstate_2.states.appointmentMissed
                    },
                    {
                        cond: guards_1.isCancelationDisabled,
                        target: xstate_2.states.cancelDisabled
                    },
                    {
                        target: xstate_2.states.cancelPage
                    }
                ]
            },
            [xstate_2.states.cancelDisabled]: {
                initial: xstate_2.states.routing,
                states: {
                    [xstate_2.states.routing]: {
                        always: [
                            {
                                cond: guards_1.isCancelationExpired,
                                target: xstate_2.states.cancelExpiredPage
                            },
                            {
                                target: xstate_2.states.cancelDisabledPage
                            }
                        ]
                    },
                    [xstate_2.states.cancelDisabledPage]: {
                    // Dead end
                    },
                    [xstate_2.states.cancelExpiredPage]: {
                    // Dead end
                    }
                }
            },
            [xstate_2.states.appointmentMissed]: {
                type: 'final'
            },
            [xstate_2.states.canceledPreviously]: {
            // Dead end
            },
            [xstate_2.states.cancelPage]: {
                initial: xstate_2.states.fetchingCancellationReasons,
                on: {
                    [xstate_2.events.selectCancellationReason]: {
                        actions: actions_1.setCancellationReason
                    }
                },
                states: {
                    [xstate_2.states.fetchingCancellationReasons]: {
                        invoke: {
                            id: 'fetchCancellationReasons',
                            src: services_1.fetchCancellationReasons,
                            onDone: {
                                actions: actions_1.setCancellationReasons,
                                target: xstate_2.states.appointmentCancel
                            },
                            onError: {
                                target: xstate_2.states.appointmentCancel
                            }
                        }
                    },
                    [xstate_2.states.appointmentCancel]: {
                        on: {
                            [xstate_2.events.cancel]: {
                                target: xstate_2.states.cancelingAppointment,
                                actions: actions_1.setCancelParameters
                            }
                        }
                    },
                    [xstate_2.states.cancelingAppointment]: {
                        invoke: {
                            id: 'deleteAppointment',
                            src: services_1.deleteAppointment,
                            onDone: {
                                target: xstate_2.states.cancelFinished
                            },
                            onError: {
                                target: xstate_2.states.cancelError
                            }
                        }
                    },
                    [xstate_2.states.cancelError]: {
                    // Dead end
                    },
                    [xstate_2.states.cancelFinished]: {
                        type: 'final'
                    }
                },
                onDone: {
                    target: xstate_2.states.confirmationPage
                }
            },
            [xstate_2.states.confirmationPage]: {
                type: 'final'
            }
        }
    }, options);
};
exports.machine = machine;
//# sourceMappingURL=main.js.map